import { useStructureContext } from '../contexts/StructureContext'
import { EntryCard } from '../common/EntryCard'
import { ContentCell, LayoutColumnContainer, LayoutGridContainer } from '../common/pure/layout'
import Heading from '../common/pure/Heading'
import t from '../../tools/t'

export default function DashboardScreen() {
    const { structure, structureLoading } = useStructureContext()
    return (
        <LayoutColumnContainer>
            <Heading size={2}>
                {structureLoading || !structure.empty ? t('common_projects') : t('structure_empty')}
            </Heading>
            <LayoutGridContainer>
                {structure.map((projectEntry) => (
                    <ContentCell key={projectEntry.id} columns={1}>
                        <EntryCard entry={projectEntry} />
                    </ContentCell>
                ))}
            </LayoutGridContainer>
        </LayoutColumnContainer>
    )
}
